function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRebookFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.347 7.528l.183-.164c1.994-1.79 4.619-2.887 7.481-2.887C22.248 4.477 27.31 9.65 27.31 16c0 .221-.006.447-.02.673l1.268-1.284 1.419 1.446-3.516 3.582c-.381.375-1.048.38-1.424-.003l-3.512-3.579 1.419-1.446 2.179 2.22c.1-.52.181-1.122.181-1.609 0-5.249-4.16-9.48-9.292-9.48-2.358 0-4.51.892-6.15 2.368l-.189.17-1.325-1.53zm-3.61 7.8l-1.26 1.293-1.42-1.447 3.51-3.576a.95.95 0 01.697-.305c.26 0 .531.108.722.303l3.503 3.578-1.409 1.448-2.178-2.228A9.255 9.255 0 006.728 16c0 5.26 4.152 9.49 9.283 9.49 2.359 0 4.5-.892 6.141-2.369l.19-.17 1.325 1.53-.182.164a11.133 11.133 0 01-7.474 2.878C9.775 27.523 4.713 22.35 4.713 16c0-.221.009-.447.024-.671z",
    fill: props.color
  }));
}

export default SvgIconRebookFilled;